// extracted by mini-css-extract-plugin
export default {"uploadRes":"NotesPanel_uploadRes__Ke6BV","formControl":"NotesPanel_formControl__59JFU","lastFiveRes":"NotesPanel_lastFiveRes__QM0U8"};